import { gql } from "@apollo/client"

const UPDATE_CUSTOMER_BILLING = gql`
  mutation UpdateCustomerBilling($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      customer {
        billing {
          address1
          address2
          city
          company
          country
          email
          firstName
          lastName
          phone
          postcode
          state
        }
      }
    }
  }
`

export default UPDATE_CUSTOMER_BILLING
